import { CONTENT_BASE_LANGUAGE } from '../content-base-language';
import { Languages } from './languages.enum';

/**
 * Countries in the Routellers roadmap (city quests / ready routes).
 * ISO 3166-1 alpha-2.
 */
export enum CountriesEnum {
    ITALY = 'it',
    SWITZERLAND = 'ch',
    LATVIA = 'lv',
    ESTONIA = 'ee',
    LITVA = 'lt',
    CZECH = 'cz',
    POLAND = 'pl',
    HUNGARY = 'hu',
    AUSTRIA = 'at',
    SLOVAKIA = 'sk',
    CROATIA = 'hr',
    PORTUGAL = 'pt',
    SPAIN = 'es',
    GREECE = 'gr',
    RUSSIA = 'ru',
    GERMANY = 'de',
    FRANCE = 'fr',
    UNITED_KINGDOM = 'gb',
    NETHERLANDS = 'nl',
    IRELAND = 'ie',
    DENMARK = 'dk',
    SWEDEN = 'se',
    BELGIUM = 'be',
    ICELAND = 'is',
    TURKEY = 'tr',
    THAILAND = 'th',
    CHINA = 'cn',
    MALAYSIA = 'my',
    VIETNAM = 'vn',
    HONG_KONG = 'hk',
    MACAU = 'mo',
    BELARUS = 'by',
    GEORGIA = 'ge',
    JAPAN = 'jp',
    ARMENIA = 'am',
    SINGAPORE = 'sg',
    SOUTH_KOREA = 'kr',
    TAIWAN = 'tw',
}

/**
 * Content languages for every city / quest / attraction / person.
 */
export const CORE_CONTENT_LANGUAGES: readonly Languages[] = [
    CONTENT_BASE_LANGUAGE,
    Languages.EN,
    Languages.IT,
    Languages.DE,
    Languages.PL,
    Languages.ES,
    Languages.FR,
] as const;

/**
 * When `cities.title` is authored in one of the content languages, that
 * language is "canonical" for the country: locale title = `cities.title`
 * without GPT translate, and entity-level inTitle/nearTitle inflect in it.
 *
 * Countries whose local tongue is outside the content set (cz, lv, …) have
 * no entry — every content locale is translated/stored independently.
 */
export const NATIVE_LANGUAGE_BY_COUNTRY: Partial<Record<CountriesEnum, Languages>> = {
    [CountriesEnum.ITALY]: Languages.IT,
    [CountriesEnum.SWITZERLAND]: Languages.IT,
    [CountriesEnum.POLAND]: Languages.PL,
    [CountriesEnum.AUSTRIA]: Languages.DE,
    [CountriesEnum.SPAIN]: Languages.ES,
    [CountriesEnum.RUSSIA]: Languages.RU,
    [CountriesEnum.GERMANY]: Languages.DE,
    [CountriesEnum.FRANCE]: Languages.FR,
    [CountriesEnum.UNITED_KINGDOM]: Languages.EN,
    [CountriesEnum.IRELAND]: Languages.EN,
    [CountriesEnum.NETHERLANDS]: Languages.EN,
    [CountriesEnum.DENMARK]: Languages.EN,
    [CountriesEnum.SWEDEN]: Languages.EN,
    [CountriesEnum.BELGIUM]: Languages.FR,
    [CountriesEnum.ICELAND]: Languages.EN,
    [CountriesEnum.TURKEY]: Languages.EN,
};

export const getRecommendedLanguages = (_country?: CountriesEnum | null): Languages[] => [
    ...CORE_CONTENT_LANGUAGES,
];

export const isRecommendedLanguage = (
    lang: string,
    country?: CountriesEnum | null,
): lang is Languages => getRecommendedLanguages(country).includes(lang as Languages);
